import React from "react";
import MarketplaceLiveStockIndex from "../components/marketplaceLiveStock";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";
import SellerIcon from "../components/commonComponents/SellerAddIcon";

export default function MarketplaceLiveStock() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {/* <TopNavbar /> */}
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <MarketplaceLiveStockIndex />
            <SellerIcon />
            <Footer />
        </div>
    )
}